module.exports = __webpack_public_path__ + "static/media/cahya.be8ce2ac.png";